// FILE: stratify_website/src/lib/navigate.js
function normalizePath(p) {
  const raw = (p || "/").trim();
  const cleaned = raw.replace(/\/+$/, "");
  return cleaned.length ? cleaned : "/";
}

function isExternal(to) {
  return (
    /^https?:\/\//i.test(to) ||
    /^mailto:/i.test(to) ||
    /^tel:/i.test(to)
  );
}

/**
 * SPA navigation without react-router:
 * - Uses real paths for SEO (/pricing, /backtesting-wallet)
 * - Uses history.pushState + dispatches popstate so hooks update
 * - Supports anchors (/pricing#section) and same-page anchors (#section)
 */
export function navigate(to, { replace = false } = {}) {
  if (typeof window === "undefined") return;
  if (!to || typeof to !== "string") return;

  // Same-page anchor (keep current pathname)
  if (to.startsWith("#")) {
    window.location.hash = to;
    const id = to.slice(1);
    requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    return;
  }

  // External links
  if (isExternal(to)) {
    window.location.assign(to);
    return;
  }

  // Split "/path?query#hash" while keeping query on the URL, not in the pathname.
  const hashIndex = to.indexOf("#");
  const withHash = hashIndex >= 0;
  const beforeHash = withHash ? to.slice(0, hashIndex) : to;
  const rawHash = withHash ? to.slice(hashIndex + 1) : "";
  const queryIndex = beforeHash.indexOf("?");
  const rawPath = queryIndex >= 0 ? beforeHash.slice(0, queryIndex) : beforeHash;
  const rawSearch = queryIndex >= 0 ? beforeHash.slice(queryIndex) : "";
  const path = normalizePath(rawPath || "/");
  const nextUrl = `${path}${rawSearch}${rawHash ? `#${rawHash}` : ""}`;

  if (replace) window.history.replaceState({}, "", nextUrl);
  else window.history.pushState({}, "", nextUrl);

  // pushState does NOT trigger popstate automatically
  window.dispatchEvent(new PopStateEvent("popstate"));

  if (rawHash) {
    requestAnimationFrame(() => {
      document.getElementById(rawHash)?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }
}
